<template>
  <div id="left-menu">
    <div id="logo">
      <div class="logo-inner">
        <img
          :src="'/static/images/Logo-Vertical' + $i18n.locale + '.svg'"
          alt=""
        />
      </div>
    </div>
    <div id="menu">
      <ul class="menu">
        <li>
          <router-link :to="{ name: 'Home' }">
            <img src="/static/images/menu-icons/home.svg" alt="" />
            <span>{{ $t("menu.home") }}</span>
          </router-link>
        </li>

        <li>
          <router-link :to="{ name: 'Courses' }">
            <img src="/static/images/menu-icons/courses.svg" alt="" />
            <span>{{ $t("menu.courses") }}</span>
          </router-link>
        </li>

        <li>
          <router-link
            :to="{
              name:
                $store.state.user.level == 'İlkokul'
                  ? 'ExercisesChild'
                  : 'Exercises',
            }"
          >
            <img src="/static/images/menu-icons/exercises.svg" alt="" />
            <span>{{ $t("menu.exercises") }}</span>
          </router-link>
        </li>

        <li v-if="$i18n.locale != 'az' && $store.state.user.level != 'İlkokul'">
          <router-link :to="{ name: 'Tests' }">
            <img src="/static/images/menu-icons/tests.svg" alt="" />
            <span>{{ $t("menu.tests") }}</span>
          </router-link>
        </li>

        <!--
          <li>
          <router-link :to="{ name: 'Settings' }">
            <img src="/static/images/menu-icons/settings.svg" alt="" />
            <span>Ayarlar</span>
          </router-link>
        </li>

-->
        <li>
          <a href="javascript:;" @click="logout">
            <img src="/static/images/menu-icons/logout.svg" alt="" />
            <span>{{ $t("menu.logout") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        padding-left: 30px;
        padding-bottom: 30px;
      "
    >
      <div
        style="
          width: 40px;
          height: 40px;
          border-radius: 10px;
          margin-right: 15px;
        "
      >
        <div class="toolbar ml-auto">
          <div class="toolbar-link">
            <label class="dark-mode ml-auto">
              <input
                type="checkbox"
                v-model="$store.state.darkmode"
                :value="1"
              />
              <span></span>
            </label>
          </div>
        </div>
      </div>

      <div style="">
        <span class="d-block text-white" style="font-weight: bold"
          >{{ $store.state.user.firstname }}
          {{ $store.state.user.lastname }}</span
        >
        <span class="text-white">Öğrenci</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftMenu",
  methods: {
    logout() {
      localStorage.removeItem("token");
      window.location.href = "/";
    },
  },
};
</script>

<style lang="less">
#left-menu {
  height: 100vh;
  width: 250px;
  background: #102d47;
  position: fixed;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  #logo {
    padding-top: 50px;
    padding-left: 50px;
    .logo-inner {
      padding: 15px;
      background: white;
      border-radius: 12px;
      box-shadow: 0px 0px 10px rgba(100, 100, 100, 0.5);
      img {
        width: 80px;
      }
    }
  }

  #menu {
    width: 100%;
    .menu {
      list-style: none;
      margin: 0px;
      padding: 0px;
      width: 100%;
      li {
        list-style: none;
        margin: 0px;
        padding: 0px;
        width: 100%;
        a {
          color: white;
          font-size: 16px;
          padding: 10px 15px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding-left: 25px;
          transition: 0.3s;
          &:hover {
            background: #f24d5d;
            transition: 0.3s;
          }
          img {
            width: 23px;
            height: 23px;
            margin-right: 25px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LeftMenu.vue